export const typeColors = {
  bug: "#729f3f",
  dragon: "#53a4cf",
  fairy: "#fdb9e9",
  fire: "#fd7d24",
  ghost: "#7b62a3",
  ground: "#f7de3f",
  normal: "#a4acaf",
  psychic: "#f366b9",
  steel: "#434b4d",
  dark: "#707070",
  electric: "#eed535",
  fighting: "#d56723",
  flying: "#3dc7ef",
  grass: "#9bcc50",
  ice: "#51c4e7",
  poison: "#b97fc9",
  rock: "#a38c21",
  water: "#4592c4",
};

export const backgroundColors = {
  fire: "#feb581",
  grass: "#DEFDE0",
  electric: "#FCF7DE",
  water: "#DEF3FD",
  ground: "#f4e7da",
  rock: "#d5d5d4",
  fairy: "#fceaff",
  poison: "#d8b7e1",
  bug: "#f8d5a3",
  dragon: "#97b3e6",
  psychic: "#f7a1d3",
  flying: "#F5F5F5",
  fighting: "#f4d2bd",
  normal: "#F5F5F5",
  ghost: "#d6cfe3",
  steel: "#434b4d",
};

export default typeColors;
